<template>
  <div class="project-space-task">
    <div class="project-navigation project-short" style="margin-top: 0px">
      <div class="spread-btn" @click="spreadSearch">
        <span class="text-btn">{{ searchSrpead ? '收起' : '高级筛选' }}</span>
        <a-icon v-if="!searchSrpead" type="down" />
        <a-icon v-else type="up" />
      </div>
      <a-input-search placeholder="项目名称/昵称/描述" style="width: 180px" class="search-item" v-model="searchName" />
      <a-select
        showSearch
        placeholder="项目关联人"
        style="width: 150px"
        class="search-item"
        :filterOption="false"
        :showArrow="false"
        @search="fetchUser"
        @change="userChange"
        @popupScroll="popupScroll"
        @dropdownVisibleChange="dropdownVisibleChange"
      >
        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
        <a-select-option v-for="d in userCompanyUserIds" :key="d.id">{{ d.nickname }}</a-select-option>
      </a-select>
      <a-select :defaultValue="currency" style="width: 150px" class="search-item" @change="currencyChange">
        <a-select-option v-for="d in currencyList" :key="d.value">{{ d.name }}</a-select-option>
      </a-select>
      <a-select :defaultValue="oldMark" style="width: 150px" class="search-item" @change="oldMarkChange">
        <a-select-option v-for="d in oldMarkList" :key="d.value">{{ d.name }}</a-select-option>
      </a-select>
      <a-select :defaultValue="sectorId" style="width: 150px" class="search-item" @change="sectorChange">
        <a-select-option v-for="d in sectorList" :key="d.id">{{ d.name }}</a-select-option>
      </a-select>
      <!-- 时间段start -->
      <a-date-picker
        :defaultValue="moment('2014-01-01 00:00:00', dateFormat)"
        v-model="startValue"
        showTime
        format="YYYY-MM-DD HH:mm:ss"
        placeholder="Start"
        :disabledDate="disabledStartDate"
        @ok="changeStartTime"
      />
      -
      <a-date-picker
        :defaultValue="moment()"
        v-model="endValue"
        showTime
        format="YYYY-MM-DD HH:mm:ss"
        placeholder="End"
        :disabledDate="disabledEndDate"
        @ok="changeEndTime"
        class="search-item"
      />
      <!-- 时间段end -->
      <!-- 只看创建日期 -->
      <!-- <a-checkbox @change="onChange" style="margin-left:10px">只看创建日期</a-checkbox> -->
      <a-select v-model="financingStage" style="width: 230px" @change="financingStageChange" class="search-item">
        <a-select-option :value="0">全部阶段</a-select-option>
        <a-select-option v-for="(name, key) in financingStageMap" :key="key" :value="+key">{{ name }}</a-select-option>
      </a-select>
      <a-select defaultValue="1" style="width: 230px" @change="onChange" class="search-item">
        <a-select-option value="1">筛选所有更新项目（含创建）</a-select-option>
        <a-select-option value="2">只筛选创建项目</a-select-option>
      </a-select>
      <div style="width: 80px; display: inline-block; height: 30px"></div>
    </div>
    <div class="spread-navigation" v-if="searchSrpead">
      <a-row type="flex" justify="space-between">
        <a-col :span="12">
          <a-select
            mode="multiple"
            label-in-value
            :value="posList"
            placeholder="搜索省份/城市"
            style="width: 100%"
            :filter-option="false"
            @search="fetchPosList"
            @change="posChange"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="pos in posMatchList" :key="pos">{{ pos }}</a-select-option>
          </a-select>
        </a-col>
        <a-row :span="6">
          <a-tooltip placement="topRight" arrow-point-at-center>
            <template slot="title">
              <span>考虑到天池系统的数据安全，有相关导出的数据需求，请联系【晴天】获取</span>
            </template>
            <a-button type="primary" disabled size="small" style="margin-right: 10px">导出</a-button>
          </a-tooltip>
        </a-row>
      </a-row>
      <a-checkbox-group :options="posOptions" :value="checkedPosOption" @change="posOptionChange" style="margin-top: 5px" />
    </div>
    <div class="project-tags" ref="tagsEl">
      <span class="label">标签：</span>
      <a-icon type="down" class="tags-down-icon" v-if="unfold" @click="clickUnfold" />
      <a-icon type="up" class="tags-up-icon" v-else @click="clickUnfold" />
      <tag v-for="(item, index) in tagsList" :key="index" :code="item.id" @change="tagsChange" style="margin: 5px">{{ item.name }}</tag>
    </div>
    <div class="project-navigation">
      <span class="label">最近浏览：</span>
      <a data-ga-id="项目列表-点击最近浏览" v-for="(item, index) in recentViewList" :key="index" @click="taskDetail(item.id)">{{ item.name }}</a>
    </div>
    <a-spin wrapperClassName="tasks-loading" :spinning="loading" v-if="!unfoldedStage">
      <div class="task-stage-container">
        <div class="board-scrum-stages">
          <div class="scrum-stage" v-for="(stage, index) in taskStages" :key="index" :class="{ 'fixed-creator': stage.fixedCreator == true }">
            <a-popover v-model="stage.menuExpanded" trigger="click" placement="bottom">
              <template slot="content">
                <a-menu class="expand-menu" mode="vertical">
                  <a-menu-item data-ga-id="项目列表-点击展开该列" key="1" @click="unfoldStage(stage)">
                    <a-icon type="menu-unfold" />
                    展开该列
                  </a-menu-item>
                </a-menu>
              </template>
              <div class="expand-container" @click="expandMenu(stage)"><span class="expand">...</span></div>
            </a-popover>
            <header class="scrum-stage-header ui-sortable-handle">
              <div class="stage-name hinted label" v-if="stage.state">
                {{ stage.state.name }}
                <span class="task-count label">&nbsp;&nbsp;&nbsp;&nbsp;{{ stage.total || 0 }}家&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                <span class="label">本周新增{{ stage.thisWeekTotal || 0 }}家</span>
              </div>
            </header>
            <div :class="['scrum-stage-wrap', 'ui-sortable', { addable: stage.state.id === 3 }]">
              <vue-scroll :ref="index + '-stage'" @handle-resize="handleResize($event, index)" @handle-scroll="handleScroll($event, index)" :ops="scrollOps">
                <section :id="stage.code" :task-type-index="index" class="scrum-stage-content thin-scroll">
                  <template v-for="(task, taskIndex) in stage.page.list">
                    <div
                      class="task done task-card ui-sortable-handle"
                      data-ga-id="项目列表-点击具体项目"
                      :index="taskIndex"
                      :key="taskIndex"
                      @click.stop="taskDetail(task.id)"
                    >
                      <div :class="['task-content-set', 'open-detail', { portfolio: task.oldMark === 2 }]">
                        <div class="task-content-wrapper">
                          <div class="task-top">
                            <div class="task-top-left">
                              <img v-if="task.logoPath" :src="task.logoPath" class="avatar img-48 hinted" />
                            </div>
                            <div class="task-top-right">
                              <div class="company_info">
                                <div class="task-content label" v-if="task">{{ task.name }}</div>
                                <div class="sector" v-if="task.sector">{{ task.sector.name }}</div>
                              </div>
                              <div>
                                <div class="member_info">
                                  <span v-for="(user, ui) in task.users" :key="ui">
                                    {{ user.nickname }}
                                    <span v-if="ui != task.users.length - 1">、</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="task-bottom">
                            <div class="task-tag">
                              <a-tag v-for="(tag, ti) in task.tags" :key="ti" color="blue">{{ tag.name }}</a-tag>
                            </div>
                          </div>
                          <div v-if="task.secret === 2" class="secret-label secret">绝密</div>
                          <div v-if="task.secret === 3" class="secret-label patent">专利</div>
                          <div v-if="task.ifProtect" class="secret-label protect">延保</div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <!--添加一个新的项目按钮-->
                  <div class="task-creator-handler-wrap" @click.stop="showProject(stage.state.id)" v-if="stage.state.id === 3">
                    <a class="task-creator-handler link-add-handler"> <a-icon type="plus-circle" style="padding-right: 6px"></a-icon>添加一个新的项目 </a>
                  </div>
                  <div class="load-more" v-if="taskStages[index].total > taskStages[index].page.page * taskStages[index].page.pageSize">
                    <a-button type="link" @click="loadMore(index)"><a-icon type="down"/></a-button>
                  </div>
                </section>
              </vue-scroll>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
    <unfold-companies
      v-if="unfoldedStage"
      :stateName="unfoldedStage.state.name"
      :stateId="unfoldedStage.state.id"
      :tagIds="tagIds"
      :searchName="searchName"
      :userId="userid"
      :sectorId="sectorId"
      :searchUserId="searchUserId"
      :startTime="startTime"
      :endTime="endTime"
      :checkedPosOption="checkedPosOption"
      :posList="posList"
      :onlyCreateTime="onlyCreateTime"
      :financingStage="financingStage"
    ></unfold-companies>
    <a-modal
      class="project-config-modal"
      :width="900"
      v-model="projectModal.modalStatus"
      :title="projectModal.modalTitle"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
    >
      <project-edit
        v-if="projectModal.modalStatus"
        :statecode="statecode"
        :usefor="'dialog'"
        @update="getCompanyList"
        @close="projectModal.modalStatus = false"
        ref="projectconfg"
      ></project-edit>
    </a-modal>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import Event from '@/utils/event';
import { tagList } from '@/api/tags';
import { searchNickName, searchNickNamePage, getMatchPosition } from '@/api/common';
import draggable from 'vuedraggable';
import { getSector, getCompanyList, getCompanyListByState, recentView, ifCanAccess } from '@/api/project';
import tag from 'components/base/tag';
import unfoldCompanies from '@/components/project/unfoldCompanies';
import projectEdit from '@/components/project/projectEdit';
import { financingStageMap } from '@/utils/project';

const defaultPosOption = [1, 2, 3];

export default {
  components: {
    draggable,
    tag,
    unfoldCompanies,
    projectEdit
  },
  data() {
    this.dateFormat = 'YYYY-MM-DD HH:mm:ss';
    return {
      sectorId: '',
      searchUserId: '',
      sectorList: [],
      loading: true,
      fetching: false,
      userCompanyUserIds: [],
      userKeyWord: '',
      userPagination: {
        page: 1,
        total: 0
      },
      userid: '',
      project: {},
      task: {}, //当前任务
      taskStages: [], //任务列表

      /*项目信息*/
      projectModal: {
        modalStatus: false,
        modalTitle: '项目信息'
      },
      searchName: this.$route.query.searchName,
      preCode: '',
      nextCode: '',
      companyId: '',
      statecode: '',
      tagIds: [],
      tagsList: [],
      recentViewList: [],
      saveHeight: '',
      unfold: true,
      unfoldedStage: null,
      onlyCreateTime: '0', //是否只看创建日期
      startValue: null, //开始时间对象
      endValue: null, //结束时间对象
      initTimeChanged: false,
      startTime: '2014-01-01 00:00:00', //开始时间
      endTime: '', //结束时间
      searchSrpead: false,
      posOptions: [
        {
          label: '总部注册所在地',
          value: 1
        },
        {
          label: '控股子公司所在地',
          value: 2
        },
        {
          label: '分公司所在地',
          value: 3
        }
      ],
      checkedPosOption: defaultPosOption,
      posList: [],
      posMatchList: [],
      currencyList: [
        {
          name: '全部币种',
          value: 0
        },
        {
          name: '人民币',
          value: 1
        },
        {
          name: '美元',
          value: 2
        },
        {
          name: '人民币及美元',
          value: 3
        }
      ],
      oldMarkList: [
        {
          name: '全部项目状态',
          value: -1
        },
        {
          name: '未上会',
          value: 0
        },
        {
          name: '已上会',
          value: 1
        },
        {
          name: 'Portfolio',
          value: 2
        }
      ],
      currency: 0,
      oldMark: -1,
      financingStageMap,
      financingStage: 0,
      isEmpty: false,
      keyword: ''
    };
  },
  watch: {
    searchName() {
      this.$ga.gaUploadCustomEvent('项目列表-搜索项目名');
      this.search();
    },
    onlyCreateTime() {
      this.search();
    }
  },
  computed: {
    scrollOps() {
      return {
        rail: {
          background: '#e5e5e5',
          opacity: 1
        },
        bar: {
          keepShow: true
        }
      };
    },
    ...mapGetters(['userInfo'])
  },
  async created() {
    this.endTime = moment().format('YYYY-MM-DD HH:mm:ss');
    this.getCompanyList();
    const { data } = await getSector();
    this.sectorList = data.filter(_ => {
      return _.status === 'NORMAL';
    });
    this.sectorList.unshift({ id: '', name: '全部sector' });
    this.tagList();
    // this.fetchUser('')
    this.recentView();
  },
  mounted() {
    Event.$on('closePoolEvent', () => {
      this.getCompanyList();
      this.unfoldedStage = null;
    });
  },
  methods: {
    moment,
    disabledStartDate(startValue) {
      const endValue = this.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    //只看创建日期
    onChange(val) {
      this.$ga.gaUploadCustomEvent('项目列表-筛选新创建项目', val);
      if (val == 1) this.onlyCreateTime = '0';
      else this.onlyCreateTime = '1';
      this.search();
    },
    //确定改变开始时间
    changeStartTime(val) {
      this.$ga.gaUploadCustomEvent('项目列表-筛选项目日期');
      this.startTime = val.format('YYYY-MM-DD HH:mm:ss');
      this.initTimeChanged = true;
      this.search();
    },
    //结束时间确定
    changeEndTime(val) {
      this.$ga.gaUploadCustomEvent('项目列表-筛选项目日期');
      this.endTime = val.format('YYYY-MM-DD HH:mm:ss');
      this.initTimeChanged = true;
      this.search();
    },
    //
    financingStageChange() {
      this.$ga.gaUploadCustomEvent('项目列表-筛选项目阶段', this.financingStage);
      this.search();
    },
    clickUnfold() {
      if (this.unfold && this.saveHeight != '') {
        document.querySelector('.project-tags').style.height = this.saveHeight + 'px';
        this.unfold = false;
      } else {
        document.querySelector('.project-tags').style.height = '32px';
        this.unfold = true;
      }
    },
    handleScroll(vertical, index) {
      if (vertical.process >= 0.99) {
        this.$ga.gaUploadCustomEvent('项目列表-滚动触底');
        this.loadMore(index);
      }
    },
    popupScroll(e) {
      // 用户列表的滚动下拉加载
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      const END = scrollHeight - scrollTop <= clientHeight;
      const GETALL = this.userCompanyUserIds.length - 1 >= this.userPagination.total;
      if (END && !GETALL) {
        this.userPagination.page++;
        this.fetching = true;
        searchNickNamePage(this.userKeyWord, this.userPagination.page).then(res => {
          this.fetching = false;
          let list = res.data.list;
          this.userPagination.total = res.data.total;
          // list.unshift({id:'',nickname: '全部'})
          this.userCompanyUserIds = this.userCompanyUserIds.concat(list);
        });
      }
    },
    dropdownVisibleChange(open) {
      open && this.fetchUser('');
    },
    recentView() {
      recentView().then(res => {
        if (res.code === 200) {
          this.recentViewList = res.data;
        } else {
          this.recentViewList = [];
        }
      });
    },
    tagsChange(obj) {
      if (obj.flag) {
        this.tagIds.push(obj.code);
      } else {
        this.tagIds.splice(this.tagIds.indexOf(obj.code), 1);
      }
      this.$ga.gaUploadCustomEvent('项目列表-筛选标签', this.tagIds.join(','));
      this.getCompanyList();
    },
    tagList() {
      tagList('company').then(res => {
        this.tagsList = res.data;
        this.$nextTick(function() {
          let offsetHeight = this.$refs.tagsEl.offsetHeight;
          if (offsetHeight > 32) {
            this.saveHeight = offsetHeight;
            document.querySelector('.project-tags').style.height = '32px';
          }
        });
      });
    },
    fetchUser(value) {
      this.fetching = true;
      this.userPagination.page = 1;
      searchNickName(value).then(res => {
        this.fetching = false;
        let list = res.data.list;
        this.userPagination.total = res.data.total;
        this.userPagination.page = res.data.page;
        list.unshift({ id: '', nickname: '全部' });
        this.userCompanyUserIds = list;
        this.userKeyWord = value;
      });
    },
    userChange(obj) {
      this.$ga.gaUploadCustomEvent('项目列表-筛选项目关联人');
      this.userid = obj;
      this.getCompanyList();
    },
    search: _.debounce(function() {
      this.getCompanyList();
    }, 500),
    async getCompanyList() {
      // if(this.unfoldedStage){
      //   return
      // }
      this.loading = true;
      let res;
      let pageSize = 15;
      const conditionBody = this.getParams();
      res = await getCompanyList({
        ...conditionBody,
        pageSize
      });
      this.loading = false;
      if (res.code === 200) {
        let taskStages = res.data;
        if (!taskStages) taskStages = [];
        taskStages.forEach(item => {
          item.fixedCreator = false;
          item.menuExpanded = false;
          if (item.total > 5) {
            item.fixedCreator = true;
          }
        });
        this.taskStages = taskStages;
      }
    },
    sectorChange(value) {
      this.$ga.gaUploadCustomEvent('筛选-选择项目sector', value);
      this.sectorId = value;
      this.getCompanyList();
    },
    currencyChange(value) {
      this.$ga.gaUploadCustomEvent('项目列表-筛选项目币种', value);
      this.currency = value;
      this.getCompanyList();
    },
    oldMarkChange(value) {
      this.$ga.gaUploadCustomEvent('项目列表-筛选项目状态', value);
      this.oldMark = value;
      this.getCompanyList();
    },
    //显示添加项目
    showProject(id) {
      this.projectModal.modalStatus = true;
      this.statecode = id;
    },
    taskDetail(id) {
      ifCanAccess({ id }).then(res => {
        if (res.code === 200 && res.data) {
          window.open(`${this.$route.path}/detail?id=${id}`);
        } else if (res.code === 200) {
          window.open(`${this.$route.path}/detail?id=${id}&noPermission=true`);
          // this.$message.error('无访问权限');
        }
      });
    },
    expandMenu(stage) {
      this.taskStages.forEach(_stage => {
        if (_stage.state.id == stage.state.id) {
          stage.menuExpanded = !stage.menuExpanded;
        }
      });
    },
    unfoldStage(stage) {
      this.unfoldedStage = this.taskStages.find(item => {
        return item.menuExpanded == true;
      });
      this.taskStages.forEach(_stage => {
        _stage.menuExpanded = false;
      });
    },
    handleResize(vertical, stageIndex) {
      if (vertical.barSize) {
        this.taskStages[stageIndex].fixedCreator = true;
      }
    },
    spreadSearch() {
      this.searchSrpead = !this.searchSrpead;
      if (!this.searchSrpead) {
        this.posList = [];
        this.checkedPosOption = defaultPosOption;
        this.search();
      }
    },
    posOptionChange(options) {
      this.checkedPosOption = options;
      this.search();
    },
    fetchPosList(keyword) {
      if (keyword.trim()) {
        getMatchPosition({
          searchName: keyword.trim()
        })
          .then(res => {
            this.posMatchList = (res && res.data && res.data.nameList) || [];
            if (this.posMatchList.length == 0) {
              this.posMatchList = [`没有找到该地区，您要找的是否为${keyword.trim()}`];
              this.isEmpty = true;
              this.keyword = keyword;
            } else {
              this.isEmpty = false;
              this.keyword = '';
            }
          })
          .catch(e => {
            this.posMatchList = [];
          });
      }
    },
    posChange(list) {
      this.$ga.gaUploadCustomEvent('项目列表-筛选项目地区');
      if (!list.length) {
        this.posMatchList = [];
      }
      if (this.isEmpty) {
        list.pop();
        list.push({
          key: this.keyword,
          label: this.keyword
        });
        this.isEmpty = false;
        this.posMatchList = [this.keyword];
      }
      this.posList = list;
      this.search();
    },
    getParams() {
      let conditionBody = {
        startTime: this.startTime,
        endTime: this.endTime,
        onlyCreateTime: this.onlyCreateTime,
        sectorId: this.sectorId,
        searchName: this.searchName,
        userCompanyUserIds: this.userid,
        joinedUserId: this.searchUserId,
        tagIds: this.tagIds.join(','),
        locationType: this.checkedPosOption.join(','),
        locationName: this.posList.map(item => item.key).join(','),
        currency: this.currency,
        oldMark: this.oldMark,
        financingStage: this.financingStage
      };
      if (this.initTimeChanged == false) {
        delete conditionBody.startTime;
        delete conditionBody.endTime;
      }
      return conditionBody;
    },
    loadMore(index) {
      let tempObj = this.taskStages[index];
      this.statecode = tempObj.state.id;
      let page = tempObj.page;
      let tempArr = tempObj.list;
      if (page.page * page.pageSize < tempObj.total) {
        page.page = ++page.page;
        const conditionBody = this.getParams();
        conditionBody.page = page.page;
        conditionBody.stateId = this.statecode;
        conditionBody.pageSize = page.pageSize;
        getCompanyListByState(conditionBody).then(res => {
          if (res.code === 200) {
            let list = res.data.list || [];
            page.list = page.list.concat(list);
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.project-navigation {
  margin: 0 !important;
}
.project-short {
  // padding-right: 80px;
  position: relative;
}
.spread-btn {
  position: absolute;
  right: 10px;
  width: 60px;
  bottom: 15px;
  color: #1890ff;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
.search-item {
  margin: 0px 16px 10px 0;
  // margin-right: 16px;
  // margin-bottom: 10px;
}
.spread-navigation {
  margin-bottom: 16px;
}
</style>
<style lang="less">
.project-tags {
  position: relative;
  overflow: hidden;
  // padding: 0 10px;
  .tags-up-icon {
    position: absolute;
    right: 5px;
    bottom: 0;
    height: 22px;
    line-height: 22px;
    width: 22px;
  }
  .tags-down-icon {
    position: absolute;
    right: 5px;
    top: 5px;
    height: 22px;
    line-height: 22px;
    width: 22px;
  }
}
@import url('../../components/project/task.less');
.task-stage-container {
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.project-space-task {
  background: #fff;
  min-height: calc(100vh - 46px);
  padding: 16px 16px 0 16px;
  // margin: 16px 16px 0 16px;
  font-size: 12px;
  .tasks-loading {
    user-select: none;
    .ant-spin-blur {
      opacity: 0;
    }
    .expand-menu {
      position: absolute;
      top: 30px;
      left: 190px;
      width: 140px;
      height: 100px;
      z-index: 1000;
      border-radius: 5px;
      box-shadow: 10px 10px 10px 10px rgba(0, 0, 0, 0.2);
    }
    .expand-container {
      position: absolute;
      right: 0;
      height: 24px;
      line-height: 12px;
      z-index: 100;
      color: black;
      &:hover {
        cursor: pointer;
      }
      .expand {
        position: absolute;
        right: 2px;
      }
      &::after {
        position: absolute;
        content: '';
        width: 0;
        height: 0;
        right: 0;
        top: 0;
        border: 12px solid;
        border-color: rgba(24, 144, 247, 0.3) rgba(24, 144, 247, 0.3) transparent transparent;
      }
    }
  }
  // .claim {
  //   width: 40px;
  //   background: rgba(57, 164, 255, 0.65);
  //   text-align: center;
  //   border-radius: 3px;
  //   color: white;
  //   font-weight: 800;
  // }
  .noClaim {
    transform: translateY(8px);
    color: #98cefb;
  }
}

.load-more {
  display: flex;
  justify-content: center;
}

.info-drawer {
  top: 116px;
  width: 0 !important;

  .ant-drawer-mask {
    visibility: hidden;
  }

  .ant-drawer-content {
    background-color: #f7f7f7;
  }

  .ant-drawer-header {
    background-color: #f7f7f7;
    text-align: center;
  }

  .ant-drawer-body {
    padding: 12px 0;
  }

  .search-content {
    padding: 0 24px;
  }
}

.info-drawer {
  .member-list {
    padding-top: 12px;

    .ant-list-item-meta {
      align-items: center;
    }

    .member-list-item {
      padding: 12px 24px;

      &:hover {
        background-color: #eee;
        cursor: pointer;
      }
    }
  }
}

.info-drawer {
  .config-wrapper {
    position: relative;
    padding-bottom: 1px;

    .config-menus {
      padding: 0;
      list-style: none;

      .menu-item {
        position: relative;
        line-height: 30px;

        &:hover {
          background: #eeeeee;
        }

        &:first-child > a {
          margin-top: -6px;
        }

        a {
          display: block;
          cursor: pointer;
          padding: 5px 15px;
          text-decoration: none;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #383838;
          font-weight: 600;

          .anticon {
            width: 24px;
            text-align: center;
            font-size: 15px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
</style>
